import { SYMBOL_HYPHEN } from './common'

export const DESC_ORDER_SYMBOL = SYMBOL_HYPHEN

export const ASC_ORDER_SYMBOL = '+'
